var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "frankinForm__stepThree step" }, [
      _c("div", { staticClass: "in container" }, [
        _c("section", { staticClass: "formIntro" }, [
          _c("div", { staticClass: "in container" }, [
            _c("h4", [_vm._v("Step 3 of 3 - Your current agreement")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "inputPanel" },
              [
                _c(
                  "div",
                  {
                    staticClass: "inputPanel__col inputPanel__question",
                    staticStyle: { margin: "0" }
                  },
                  [
                    _c("label", { staticStyle: { "font-weight": "500" } }, [
                      _vm._v(
                        "\n                For this section you will need:\n                "
                      ),
                      _c("ul", [
                        _vm.step1.franking_contract == "yes"
                          ? _c("li", [
                              _vm._v(
                                "\n                    - A copy of a recent lease agreement\n                  "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v(
                            "\n                    - A copy of your last service invoice\n                  "
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v(
                            "\n                    - A copy of your originally signed agreements\n                  "
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "margin-top": "20px",
                          "font-size": "1.4rem",
                          "line-height": "1.4",
                          "margin-bottom": "2.125rem",
                          color: "#363636"
                        }
                      },
                      [
                        _vm._v(
                          "\n                Don’t worry if you don’t have this information we can still support you, chat with us or click here for more info.\n              "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.step1.franking_contract == "yes"
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              "margin-top": "20px",
                              "font-size": "1.4rem",
                              "line-height": "1.4",
                              "margin-bottom": "2.125rem",
                              color: "#363636"
                            }
                          },
                          [
                            _vm._v(
                              "\n                If you are still in contract we will look to source a quote which includes paying off your current agreement so your business can benefit from savings and new technology now without waiting\n              "
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "inputPanel__col inputPanel__input inputPanel__input--groupFull inputPanel__input--selectaproduct"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "box box--text",
                        staticStyle: { width: "100%", cursor: "pointer" },
                        attrs: { onclick: "" },
                        on: {
                          click: function() {
                            _vm.$refs.clickItem1.click()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                What do I do if I don't have this information?\n              "
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "inputPanel__col inputPanel__info" }, [
                  _c(
                    "div",
                    {
                      ref: "clickItem1",
                      staticClass: "infoIcon",
                      attrs: { "data-tip": "Info here" }
                    },
                    [_vm._v("\n                i\n              ")]
                  )
                ]),
                _vm._v(" "),
                _c("info-modal", [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        color: "#fff",
                        "margin-bottom": "20px",
                        display: "block"
                      }
                    },
                    [
                      _vm._v(
                        "If you are not sure whether you lease or own your equipment the best way to check is to review your latest invoice. Purchased equipment will typically be invoiced for service/maintenance annually only, whereas leased/rented equipment will be invoiced, monthly, quarterly or annually and the lease/rental costs will invoice separately from the service/maintenance costs.\n              "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              The below graphic shows typical invoices with the key information highlighted;\n              Rental costs circled in Green,\n              Maintenance/Service Costs circled in Orange,\n              ValueMax/Insurance waiver fees in Red,\n              Invoice Fees circled in Blue\n              "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              The payment frequency is circled in Purple\n              "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              **We offer a service to allow us to get all necessary information and detail on your behalf. "
                      ),
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "https://themailingexpert.com/let-us-do-it-for-you/",
                            target: "_blank"
                          }
                        },
                        [_vm._v("Click here")]
                      ),
                      _vm._v(" to request this free service.**")
                    ]
                  ),
                  _vm._v(" "),
                  _c("img", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      src:
                        "/static/styles/mailkit/img/lease-information-pop-up.png",
                      alt: ""
                    }
                  })
                ])
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _vm.step1.franking_contract == "no_purchased"
          ? _c(
              "div",
              {
                staticClass: "inputPanel",
                class: {
                  inputPanel__error:
                    _vm.invalidFields.annual_maintenance_package_cost
                }
              },
              [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "inputPanel__col inputPanel__input inputPanel__input--groupFull"
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.annual_maintenance_package_cost,
                          expression: "annual_maintenance_package_cost"
                        },
                        {
                          name: "positive-numbers-only",
                          rawName: "v-positive-numbers-only"
                        }
                      ],
                      staticClass: "inputReg",
                      attrs: {
                        type: "text",
                        name: "payforannualmaintenance",
                        id: "payforannualmaintenance",
                        placeholder: "Enter Value"
                      },
                      domProps: { value: _vm.annual_maintenance_package_cost },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.annual_maintenance_package_cost =
                            $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("error-modal", [
                      _vm._v(
                        "\n            The best place to locate this information is your last service invoice and if you are charged for rate up dates please add this charge to the annual service cost you pay. Rate charges are often applied around March/April each year where your service cover does not include this provision.\n            "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n            **We offer a service to allow us to get all necessary information and detail on your behalf. "
                      ),
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "https://themailingexpert.com/let-us-do-it-for-you/",
                            target: "_blank"
                          }
                        },
                        [_vm._v("Click here")]
                      ),
                      _vm._v(" to request this free service.**\n          ")
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("info-modal", [
                  _vm._v(
                    "\n          The best place to locate this information is your last service invoice and if you are charged for rate up dates please add this charge to the annual service cost you pay. Rate charges are often applied around March/April each year where your service cover does not include this provision.\n          "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n          **We offer a service to allow us to get all necessary information and detail on your behalf. "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "https://themailingexpert.com/let-us-do-it-for-you/",
                        target: "_blank"
                      }
                    },
                    [_vm._v("Click here")]
                  ),
                  _vm._v(" to request this free service.**\n          "),
                  _c("img", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      src:
                        "/static/styles/mailkit/img/service-information-pop-up.png",
                      alt: ""
                    }
                  })
                ])
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.step1.franking_contract != "no_purchased"
          ? _c(
              "div",
              [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "frankinForm__dateBlock",
                    class: {
                      inputPanel__error:
                        _vm.invalidFields.lease_end_month ||
                        _vm.invalidFields.lease_end_year ||
                        _vm.invalidFields.lease_start_month ||
                        _vm.invalidFields.lease_start_year
                    }
                  },
                  [
                    _c("div", { staticClass: "inputPanel" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "inputPanel__col inputPanel__question inputPanel__question--right"
                        },
                        [
                          _c("label", [_vm._v("When did your lease start?")]),
                          _vm._v(" "),
                          _vm._m(2),
                          _vm._v(" "),
                          _c("info-modal", [
                            _vm._v(
                              "\n                To help you find the relevant information from your existing agreement we have provided below some lease agreement examples to help you locate the required information.\n                "
                            ),
                            _c("br"),
                            _vm._v(
                              "\n                The below graphic shows typical agreements with the key information highlighted;\n                The start date isn’t necessarily the date the agreement was signed, this is actually normally the accepted or dispatched date. Please use the accepted or dispatched date where you have this information. In our examples this is circled in Green.\n                "
                            ),
                            _c("br"),
                            _vm._v(
                              "\n                If this isn’t noted please use the contract signed date, in these examples this is circled in Orange.\n                "
                            ),
                            _c("br"),
                            _vm._v(
                              "\n                To help you locate the key information regarding the term i.e. duration and payment frequency we have highlighted these areas by circling in Purple.\n                "
                            ),
                            _c("br"),
                            _vm._v(
                              "\n                **We offer a service to allow us to get all necessary information and detail on your behalf. "
                            ),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href:
                                    "https://themailingexpert.com/let-us-do-it-for-you/",
                                  target: "_blank"
                                }
                              },
                              [_vm._v("Click here")]
                            ),
                            _vm._v(
                              " to request this free service.**\n                "
                            ),
                            _c("img", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                src:
                                  "/static/styles/mailkit/img/lease-agreement-information.png",
                                alt: ""
                              }
                            })
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "inputPanel__col inputPanel__input inputPanel__input--inlineTwo"
                        },
                        [
                          _c("div", { staticClass: "smallSelect" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.lease_start_month,
                                    expression: "lease_start_month"
                                  }
                                ],
                                attrs: { name: "leasestartone" },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.lease_start_month = $event.target
                                      .multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              [
                                _c(
                                  "option",
                                  {
                                    attrs: { disabled: "", selected: "" },
                                    domProps: { value: null }
                                  },
                                  [_vm._v("Month")]
                                ),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.numberedDropdown(1, 12, false, true),
                                  function(month, name) {
                                    return _c(
                                      "option",
                                      { domProps: { value: month } },
                                      [_vm._v(_vm._s(name))]
                                    )
                                  }
                                )
                              ],
                              2
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "smallSelect" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.lease_start_year,
                                    expression: "lease_start_year"
                                  }
                                ],
                                attrs: { name: "leasestarttwo" },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.lease_start_year = $event.target
                                      .multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              [
                                _c(
                                  "option",
                                  {
                                    attrs: { disabled: "", selected: "" },
                                    domProps: { value: null }
                                  },
                                  [_vm._v("Year")]
                                ),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.numberedDropdown(
                                    _vm.minYears,
                                    _vm.maxYears,
                                    true
                                  ),
                                  function(year) {
                                    return _c(
                                      "option",
                                      { domProps: { value: year } },
                                      [_vm._v(_vm._s(year))]
                                    )
                                  }
                                )
                              ],
                              2
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "inputPanel" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "inputPanel__col inputPanel__question inputPanel__question--right"
                        },
                        [
                          _c("label", [
                            _vm._v("When does your agreement end?")
                          ]),
                          _vm._v(" "),
                          _vm._m(3),
                          _vm._v(" "),
                          _c("info-modal", [
                            _vm._v(
                              "\n                To help you find the relevant information from your existing agreement we have provided below some lease agreement examples to help you locate the required information.\n                "
                            ),
                            _c("br"),
                            _vm._v(
                              "\n                The below graphic shows typical agreements with the key information highlighted;\n                The start date isn’t necessarily the date the agreement was signed, this is actually normally the accepted or dispatched date. Please use the accepted or dispatched date where you have this information. In our examples this is circled in Green.\n                "
                            ),
                            _c("br"),
                            _vm._v(
                              "\n                If this isn’t noted please use the contract signed date, in these examples this is circled in Orange.\n                "
                            ),
                            _c("br"),
                            _vm._v(
                              "\n                To help you locate the key information regarding the term i.e. duration and payment frequency we have highlighted these areas by circling in Purple.\n                "
                            ),
                            _c("br"),
                            _vm._v(
                              "\n                **We offer a service to allow us to get all necessary information and detail on your behalf. "
                            ),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href:
                                    "https://themailingexpert.com/let-us-do-it-for-you/",
                                  target: "_blank"
                                }
                              },
                              [_vm._v("Click here")]
                            ),
                            _vm._v(
                              " to request this free service.**\n                "
                            ),
                            _c("img", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                src:
                                  "/static/styles/mailkit/img/lease-agreement-information.png",
                                alt: ""
                              }
                            })
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "inputPanel__col inputPanel__input inputPanel__input--inlineTwo"
                        },
                        [
                          _c("div", { staticClass: "smallSelect" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.lease_end_month,
                                    expression: "lease_end_month"
                                  }
                                ],
                                attrs: { name: "agreementendone" },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.lease_end_month = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              [
                                _c(
                                  "option",
                                  {
                                    attrs: { disabled: "", selected: "" },
                                    domProps: { value: null }
                                  },
                                  [_vm._v("Month")]
                                ),
                                _vm._v(" "),
                                _c("option", { domProps: { value: 0 } }, [
                                  _vm._v("I don't know")
                                ]),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.numberedDropdown(1, 12, false, true),
                                  function(month, name) {
                                    return _c(
                                      "option",
                                      { domProps: { value: month } },
                                      [_vm._v(_vm._s(name))]
                                    )
                                  }
                                )
                              ],
                              2
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "smallSelect" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.lease_end_year,
                                    expression: "lease_end_year"
                                  }
                                ],
                                attrs: { name: "agreementendtwo" },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.lease_end_year = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              [
                                _c(
                                  "option",
                                  {
                                    attrs: { disabled: "", selected: "" },
                                    domProps: { value: null }
                                  },
                                  [_vm._v("Year")]
                                ),
                                _vm._v(" "),
                                _c("option", { domProps: { value: 0 } }, [
                                  _vm._v("I don't know")
                                ]),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.numberedDropdown(
                                    _vm.minYears + 7,
                                    _vm.maxYears + 8,
                                    true
                                  ),
                                  function(year) {
                                    return _c(
                                      "option",
                                      { domProps: { value: year } },
                                      [_vm._v(_vm._s(year))]
                                    )
                                  }
                                )
                              ],
                              2
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("error-modal", [
                      _vm._v(
                        "\n            To help you find the relevant information from your existing agreement we have provided below some lease agreement examples to help you locate the required information.\n            "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n            The below graphic shows typical agreements with the key information highlighted;\n            The start date isn’t necessarily the date the agreement was signed, this is actually normally the accepted or dispatched date. Please use the accepted or dispatched date where you have this information. In our examples this is circled in Green.\n            "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n            If this isn’t noted please use the contract signed date, in these examples this is circled in Orange.\n            "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n            To help you locate the key information regarding the term i.e. duration and payment frequency we have highlighted these areas by circling in Purple.\n            "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n            **We offer a service to allow us to get all necessary information and detail on your behalf. "
                      ),
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "https://themailingexpert.com/let-us-do-it-for-you/",
                            target: "_blank"
                          }
                        },
                        [_vm._v("Click here")]
                      ),
                      _vm._v(" to request this free service.**\n            "),
                      _c("img", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          src:
                            "/static/styles/mailkit/img/lease-agreement-information.png",
                          alt: ""
                        }
                      })
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.lease_end_month === 0 || _vm.lease_end_year === 0
                  ? _c(
                      "div",
                      {
                        staticClass: "frankinForm__dateBlock",
                        class: {
                          inputPanel__error:
                            _vm.invalidFields.lease_billing_period ||
                            _vm.invalidFields.lease_payments_made
                        }
                      },
                      [
                        _vm._m(4),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "inputPanel" },
                          [
                            _vm._m(5),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "inputPanel__col inputPanel__input inputPanel__input--inlineTwo"
                              },
                              [
                                _c("div", { staticClass: "smallSelect" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.lease_billing_period,
                                          expression: "lease_billing_period"
                                        }
                                      ],
                                      attrs: {
                                        name: "currentagreementtermone"
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.lease_billing_period = $event
                                            .target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        {
                                          attrs: { disabled: "", selected: "" },
                                          domProps: { value: null }
                                        },
                                        [_vm._v("Billing Period")]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(_vm.billingPeriods, function(
                                        title,
                                        period
                                      ) {
                                        return _c(
                                          "option",
                                          { domProps: { value: period } },
                                          [_vm._v(_vm._s(title))]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "smallSelect" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.lease_payments_made,
                                          expression: "lease_payments_made"
                                        }
                                      ],
                                      attrs: {
                                        name: "currentagreementtermtwo"
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.lease_payments_made = $event
                                            .target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        {
                                          attrs: { disabled: "", selected: "" },
                                          domProps: { value: null }
                                        },
                                        [_vm._v("Payments")]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.numberedDropdown(
                                          1,
                                          _vm.getLeaseMaxNumber(),
                                          false,
                                          false
                                        ),
                                        function(number) {
                                          return _c(
                                            "option",
                                            { domProps: { value: number } },
                                            [_vm._v(_vm._s(number))]
                                          )
                                        }
                                      )
                                    ],
                                    2
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("info-modal", [
                              _vm._v(
                                "\n              To help you find the relevant information from your existing agreement we have provided below some lease agreement examples to help you locate the required information.\n              "
                              ),
                              _c("br"),
                              _vm._v(
                                "\n              The below graphic shows typical agreements with the key information highlighted;\n              The start date isn’t necessarily the date the agreement was signed, this is actually normally the accepted or dispatched date. Please use the accepted or dispatched date where you have this information. In our examples this is circled in Green.\n              "
                              ),
                              _c("br"),
                              _vm._v(
                                "\n              If this isn’t noted please use the contract signed date, in these examples this is circled in Orange.\n              "
                              ),
                              _c("br"),
                              _vm._v(
                                "\n              To help you locate the key information regarding the term i.e. duration and payment frequency we have highlighted these areas by circling in Purple.\n              "
                              ),
                              _c("br"),
                              _vm._v(
                                "\n              **We offer a service to allow us to get all necessary information and detail on your behalf. "
                              ),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "https://themailingexpert.com/let-us-do-it-for-you/",
                                    target: "_blank"
                                  }
                                },
                                [_vm._v("Click here")]
                              ),
                              _vm._v(
                                " to request this free service.**\n              "
                              ),
                              _c("img", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  src:
                                    "/static/styles/mailkit/img/lease-agreement-information.png",
                                  alt: ""
                                }
                              })
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("error-modal", [
                          _vm._v(
                            "\n            To help you find the relevant information from your existing agreement we have provided below some lease agreement examples to help you locate the required information.\n            "
                          ),
                          _c("br"),
                          _vm._v(
                            "\n            The below graphic shows typical agreements with the key information highlighted;\n            The start date isn’t necessarily the date the agreement was signed, this is actually normally the accepted or dispatched date. Please use the accepted or dispatched date where you have this information. In our examples this is circled in Green.\n            "
                          ),
                          _c("br"),
                          _vm._v(
                            "\n            If this isn’t noted please use the contract signed date, in these examples this is circled in Orange.\n            "
                          ),
                          _c("br"),
                          _vm._v(
                            "\n            To help you locate the key information regarding the term i.e. duration and payment frequency we have highlighted these areas by circling in Purple.\n            "
                          ),
                          _c("br"),
                          _vm._v(
                            "\n            **We offer a service to allow us to get all necessary information and detail on your behalf. "
                          ),
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  "https://themailingexpert.com/let-us-do-it-for-you/",
                                target: "_blank"
                              }
                            },
                            [_vm._v("Click here")]
                          ),
                          _vm._v(
                            " to request this free service.**\n            "
                          ),
                          _c("img", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              src:
                                "/static/styles/mailkit/img/lease-agreement-information.png",
                              alt: ""
                            }
                          })
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "frankinForm__dateBlock",
                    class: {
                      inputPanel__error:
                        _vm.invalidFields.lease_cost ||
                        _vm.invalidFields.lease_frequency
                    }
                  },
                  [
                    _c("div", { staticClass: "inputPanel" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "inputPanel__col inputPanel__question inputPanel__question--right"
                        },
                        [
                          _c("label", [
                            _vm._v("Current rental/lease (excluding service)?")
                          ]),
                          _vm._v(" "),
                          _vm._m(6),
                          _vm._v(" "),
                          _c("info-modal", [
                            _vm._v(
                              "\n                If you are not sure whether you lease or own your equipment the best way to check is to review your latest invoice. Purchased equipment will typically be invoiced for service/maintenance annually only, whereas leased/rented equipment will be invoiced, monthly, quarterly or annually and the lease/rental costs will invoice separately from the service/maintenance costs.\n                "
                            ),
                            _c("br"),
                            _vm._v(
                              "\n                The below graphic shows typical invoices with the key information highlighted;\n                Rental costs circled in Green,\n                Maintenance/Service Costs circled in Orange,\n                ValueMax/Insurance waiver fees in Red,\n                Invoice Fees circled in Blue\n                "
                            ),
                            _c("br"),
                            _vm._v(
                              "\n                The payment frequency is circled in Purple\n                "
                            ),
                            _c("br"),
                            _vm._v(
                              "\n                **We offer a service to allow us to get all necessary information and detail on your behalf. "
                            ),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href:
                                    "https://themailingexpert.com/let-us-do-it-for-you/",
                                  target: "_blank"
                                }
                              },
                              [_vm._v("Click here")]
                            ),
                            _vm._v(
                              " to request this free service.**\n                "
                            ),
                            _c("img", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                src:
                                  "/static/styles/mailkit/img/lease-information-pop-up.png",
                                alt: ""
                              }
                            })
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "inputPanel__col inputPanel__input inputPanel__input--inlineTwo"
                        },
                        [
                          _c("div", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.lease_cost,
                                  expression: "lease_cost"
                                },
                                {
                                  name: "positive-numbers-only",
                                  rawName: "v-positive-numbers-only"
                                }
                              ],
                              staticClass: "inputReg",
                              attrs: {
                                id: "leaseCostStep3",
                                type: "number",
                                placeholder: "Enter Cost"
                              },
                              domProps: { value: _vm.lease_cost },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.lease_cost = $event.target.value
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "smallSelect" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.lease_frequency,
                                    expression: "lease_frequency"
                                  }
                                ],
                                attrs: { name: "currentservicecosttwo" },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.lease_frequency = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              [
                                _c(
                                  "option",
                                  {
                                    attrs: { disabled: "", selected: "" },
                                    domProps: { value: null }
                                  },
                                  [_vm._v("Frequency")]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.billingPeriods, function(
                                  title,
                                  period
                                ) {
                                  return _c(
                                    "option",
                                    { domProps: { value: period } },
                                    [_vm._v(_vm._s(title))]
                                  )
                                })
                              ],
                              2
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("error-modal", [
                      _vm._v(
                        "\n            If you are not sure whether you lease or own your equipment the best way to check is to review your latest invoice. Purchased equipment will typically be invoiced for service/maintenance annually only, whereas leased/rented equipment will be invoiced, monthly, quarterly or annually and the lease/rental costs will invoice separately from the service/maintenance costs.\n            "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n            The below graphic shows typical invoices with the key information highlighted;\n            Rental costs circled in Green,\n            Maintenance/Service Costs circled in Orange,\n            ValueMax/Insurance waiver fees in Red,\n            Invoice Fees circled in Blue\n            "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n            The payment frequency is circled in Purple\n            "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n            **We offer a service to allow us to get all necessary information and detail on your behalf. "
                      ),
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "https://themailingexpert.com/let-us-do-it-for-you/",
                            target: "_blank"
                          }
                        },
                        [_vm._v("Click here")]
                      ),
                      _vm._v(" to request this free service.**\n            "),
                      _c("img", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          src:
                            "/static/styles/mailkit/img/lease-agreement-information.png",
                          alt: ""
                        }
                      })
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "frankinForm__dateBlock",
                    class: {
                      inputPanel__error:
                        _vm.invalidFields.service_cost ||
                        _vm.invalidFields.service_frequency
                    }
                  },
                  [
                    _c("div", { staticClass: "inputPanel" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "inputPanel__col inputPanel__question inputPanel__question--right"
                        },
                        [
                          _c("label", [_vm._v("Current service cost?")]),
                          _vm._v(" "),
                          _vm._m(7),
                          _vm._v(" "),
                          _c("info-modal", [
                            _vm._v(
                              "\n                If you are not sure whether you lease or own your equipment the best way to check is to review your latest invoice. Purchased equipment will typically be invoiced for service/maintenance annually only, whereas leased/rented equipment will be invoiced, monthly, quarterly or annually and the lease/rental costs will invoice separately from the service/maintenance costs.\n                "
                            ),
                            _c("br"),
                            _vm._v(
                              "\n                The below graphic shows typical invoices with the key information highlighted;\n                Rental costs circled in Green,\n                Maintenance/Service Costs circled in Orange,\n                ValueMax/Insurance waiver fees in Red,\n                Invoice Fees circled in Blue\n                "
                            ),
                            _c("br"),
                            _vm._v(
                              "\n                The payment frequency is circled in Purple\n                "
                            ),
                            _c("br"),
                            _vm._v(
                              "\n                **We offer a service to allow us to get all necessary information and detail on your behalf. "
                            ),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href:
                                    "https://themailingexpert.com/let-us-do-it-for-you/",
                                  target: "_blank"
                                }
                              },
                              [_vm._v("Click here")]
                            ),
                            _vm._v(
                              " to request this free service.**\n                "
                            ),
                            _c("img", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                src:
                                  "/static/styles/mailkit/img/lease-information-pop-up.png",
                                alt: ""
                              }
                            })
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "inputPanel__col inputPanel__input inputPanel__input--inlineTwo"
                        },
                        [
                          _c("div", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.service_cost,
                                  expression: "service_cost"
                                },
                                {
                                  name: "positive-numbers-only",
                                  rawName: "v-positive-numbers-only"
                                }
                              ],
                              staticClass: "inputReg",
                              attrs: {
                                id: "serviceCostStep3",
                                type: "number",
                                placeholder: "Enter Cost"
                              },
                              domProps: { value: _vm.service_cost },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.service_cost = $event.target.value
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "smallSelect" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.service_frequency,
                                    expression: "service_frequency"
                                  }
                                ],
                                attrs: { name: "stuffstuff" },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.service_frequency = $event.target
                                      .multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              [
                                _c(
                                  "option",
                                  {
                                    attrs: { disabled: "", selected: "" },
                                    domProps: { value: null }
                                  },
                                  [_vm._v("Frequency")]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.billingPeriods, function(
                                  title,
                                  period
                                ) {
                                  return _c(
                                    "option",
                                    { domProps: { value: period } },
                                    [_vm._v(_vm._s(title))]
                                  )
                                })
                              ],
                              2
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("error-modal", [
                      _vm._v(
                        "\n            If you are not sure whether you lease or own your equipment the best way to check is to review your latest invoice. Purchased equipment will typically be invoiced for service/maintenance annually only, whereas leased/rented equipment will be invoiced, monthly, quarterly or annually and the lease/rental costs will invoice separately from the service/maintenance costs.\n            "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n            The below graphic shows typical invoices with the key information highlighted;\n            Rental costs circled in Green,\n            Maintenance/Service Costs circled in Orange,\n            ValueMax/Insurance waiver fees in Red,\n            Invoice Fees circled in Blue\n            "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n            The payment frequency is circled in Purple\n            "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n            **We offer a service to allow us to get all necessary information and detail on your behalf. "
                      ),
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "https://themailingexpert.com/let-us-do-it-for-you/",
                            target: "_blank"
                          }
                        },
                        [_vm._v("Click here")]
                      ),
                      _vm._v(
                        " to request this free service.**\n              "
                      ),
                      _c("img", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          src:
                            "/static/styles/mailkit/img/lease-agreement-information.png",
                          alt: ""
                        }
                      })
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "frankinForm__dateBlock",
                    class: {
                      inputPanel__error:
                        _vm.invalidFields.invoice_fee_cost ||
                        _vm.invalidFields.invoice_fee_frequency
                    }
                  },
                  [
                    _c("div", { staticClass: "inputPanel" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "inputPanel__col inputPanel__question inputPanel__question--right"
                        },
                        [
                          _c("label", [
                            _vm._v(
                              "Do you pay any invoice fees (check lease invoice and confirm cost)?"
                            )
                          ]),
                          _vm._v(" "),
                          _vm._m(8),
                          _vm._v(" "),
                          _c("info-modal", [
                            _vm._v(
                              "\n                If you are not sure whether you lease or own your equipment the best way to check is to review your latest invoice. Purchased equipment will typically be invoiced for service/maintenance annually only, whereas leased/rented equipment will be invoiced, monthly, quarterly or annually and the lease/rental costs will invoice separately from the service/maintenance costs.\n                "
                            ),
                            _c("br"),
                            _vm._v(
                              "\n                The below graphic shows typical invoices with the key information highlighted;\n                Rental costs circled in Green,\n                Maintenance/Service Costs circled in Orange,\n                ValueMax/Insurance waiver fees in Red,\n                Invoice Fees circled in Blue\n                "
                            ),
                            _c("br"),
                            _vm._v(
                              "\n                The payment frequency is circled in Purple\n                "
                            ),
                            _c("br"),
                            _vm._v(
                              "\n                **We offer a service to allow us to get all necessary information and detail on your behalf. "
                            ),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href:
                                    "https://themailingexpert.com/let-us-do-it-for-you/",
                                  target: "_blank"
                                }
                              },
                              [_vm._v("Click here")]
                            ),
                            _vm._v(
                              " to request this free service.**\n                "
                            ),
                            _c("img", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                src:
                                  "/static/styles/mailkit/img/lease-information-pop-up.png",
                                alt: ""
                              }
                            })
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "inputPanel__col inputPanel__input inputPanel__input--inlineTwo"
                        },
                        [
                          _c("div", { staticClass: "smallSelect" }, [
                            _c("div", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.invoice_fee_cost,
                                    expression: "invoice_fee_cost"
                                  },
                                  {
                                    name: "positive-numbers-only",
                                    rawName: "v-positive-numbers-only"
                                  }
                                ],
                                staticClass: "inputReg",
                                attrs: {
                                  id: "invoiceFeecostStep3",
                                  type: "number",
                                  placeholder: "Enter Cost"
                                },
                                domProps: { value: _vm.invoice_fee_cost },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.invoice_fee_cost = $event.target.value
                                  }
                                }
                              })
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "smallSelect" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.invoice_fee_frequency,
                                    expression: "invoice_fee_frequency"
                                  }
                                ],
                                class: { active: _vm.invoice_fee_frequency },
                                attrs: { name: "invoicefeestwo" },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.invoice_fee_frequency = $event.target
                                      .multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              [
                                _c(
                                  "option",
                                  {
                                    attrs: { disabled: "", selected: "" },
                                    domProps: { value: null }
                                  },
                                  [_vm._v("Frequency")]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.billingPeriods, function(
                                  title,
                                  period
                                ) {
                                  return _c(
                                    "option",
                                    { domProps: { value: period } },
                                    [_vm._v(_vm._s(title))]
                                  )
                                })
                              ],
                              2
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("error-modal", [
                      _vm._v(
                        "\n            If you are not sure whether you lease or own your equipment the best way to check is to review your latest invoice. Purchased equipment will typically be invoiced for service/maintenance annually only, whereas leased/rented equipment will be invoiced, monthly, quarterly or annually and the lease/rental costs will invoice separately from the service/maintenance costs.\n            "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n            The below graphic shows typical invoices with the key information highlighted;\n            Rental costs circled in Green,\n            Maintenance/Service Costs circled in Orange,\n            ValueMax/Insurance waiver fees in Red,\n            Invoice Fees circled in Blue\n            "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n            The payment frequency is circled in Purple\n            "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n            **We offer a service to allow us to get all necessary information and detail on your behalf. "
                      ),
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "https://themailingexpert.com/let-us-do-it-for-you/",
                            target: "_blank"
                          }
                        },
                        [_vm._v("Click here")]
                      ),
                      _vm._v(" to request this free service.**\n            "),
                      _c("img", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          src:
                            "/static/styles/mailkit/img/lease-agreement-information.png",
                          alt: ""
                        }
                      })
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "frankinForm__dateBlock",
                    class: {
                      inputPanel__error:
                        _vm.invalidFields.insurance_fee_cost ||
                        _vm.invalidFields.insurance_fee_frequency
                    }
                  },
                  [
                    _c("div", { staticClass: "inputPanel" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "inputPanel__col inputPanel__question inputPanel__question--right"
                        },
                        [
                          _c("label", [
                            _vm._v(
                              "Do you pay any insurance fees (check lease invoice)?"
                            )
                          ]),
                          _vm._v(" "),
                          _vm._m(9),
                          _vm._v(" "),
                          _c("info-modal", [
                            _vm._v(
                              "\n                If you are not sure whether you lease or own your equipment the best way to check is to review your latest invoice. Purchased equipment will typically be invoiced for service/maintenance annually only, whereas leased/rented equipment will be invoiced, monthly, quarterly or annually and the lease/rental costs will invoice separately from the service/maintenance costs.\n                "
                            ),
                            _c("br"),
                            _vm._v(
                              "\n                The below graphic shows typical invoices with the key information highlighted;\n                Rental costs circled in Green,\n                Maintenance/Service Costs circled in Orange,\n                ValueMax/Insurance waiver fees in Red,\n                Invoice Fees circled in Blue\n                "
                            ),
                            _c("br"),
                            _vm._v(
                              "\n                The payment frequency is circled in Purple\n                "
                            ),
                            _c("br"),
                            _vm._v(
                              "\n                **We offer a service to allow us to get all necessary information and detail on your behalf. "
                            ),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href:
                                    "https://themailingexpert.com/let-us-do-it-for-you/",
                                  target: "_blank"
                                }
                              },
                              [_vm._v("Click here")]
                            ),
                            _vm._v(
                              " to request this free service.**\n                "
                            ),
                            _c("img", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                src:
                                  "/static/styles/mailkit/img/lease-information-pop-up.png",
                                alt: ""
                              }
                            })
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "inputPanel__col inputPanel__input inputPanel__input--inlineTwo"
                        },
                        [
                          _c("div", { staticClass: "smallSelect" }, [
                            _c("div", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.insurance_fee_cost,
                                    expression: "insurance_fee_cost"
                                  },
                                  {
                                    name: "positive-numbers-only",
                                    rawName: "v-positive-numbers-only"
                                  }
                                ],
                                staticClass: "inputReg",
                                attrs: {
                                  id: "insuranceFeecostStep3",
                                  type: "number",
                                  placeholder: "Enter Cost"
                                },
                                domProps: { value: _vm.insurance_fee_cost },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.insurance_fee_cost = $event.target.value
                                  }
                                }
                              })
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "smallSelect" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.insurance_fee_frequency,
                                    expression: "insurance_fee_frequency"
                                  }
                                ],
                                class: { active: _vm.insurance_fee_frequency },
                                attrs: { name: "insurancefeestwo" },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.insurance_fee_frequency = $event.target
                                      .multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              [
                                _c(
                                  "option",
                                  {
                                    attrs: { disabled: "", selected: "" },
                                    domProps: { value: null }
                                  },
                                  [_vm._v("Frequency")]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.billingPeriods, function(
                                  title,
                                  period
                                ) {
                                  return _c(
                                    "option",
                                    { domProps: { value: period } },
                                    [_vm._v(_vm._s(title))]
                                  )
                                })
                              ],
                              2
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("error-modal", [
                      _vm._v(
                        "\n            If you are not sure whether you lease or own your equipment the best way to check is to review your latest invoice. Purchased equipment will typically be invoiced for service/maintenance annually only, whereas leased/rented equipment will be invoiced, monthly, quarterly or annually and the lease/rental costs will invoice separately from the service/maintenance costs.\n            "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n            The below graphic shows typical invoices with the key information highlighted;\n            Rental costs circled in Green,\n            Maintenance/Service Costs circled in Orange,\n            ValueMax/Insurance waiver fees in Red,\n            Invoice Fees circled in Blue\n            "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n            The payment frequency is circled in Purple\n            "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n            **We offer a service to allow us to get all necessary information and detail on your behalf. "
                      ),
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "https://themailingexpert.com/let-us-do-it-for-you/",
                            target: "_blank"
                          }
                        },
                        [_vm._v("Click here")]
                      ),
                      _vm._v(" to request this free service.**\n            "),
                      _c("img", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          src:
                            "/static/styles/mailkit/img/lease-agreement-information.png",
                          alt: ""
                        }
                      })
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.invalidFields && Object.keys(_vm.invalidFields).length > 0
                  ? _c("invalid-fields")
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "frankinForm__saveProgress saveProgress saveProgress--full saveProgress--paddingLarge"
          },
          [
            _c("div", { staticClass: "in" }, [
              _vm._m(10),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "saveProgress__form saveProgress__form--noInputs saveProgress__form--noMarginBottom"
                },
                [
                  _c("input", {
                    attrs: {
                      type: "submit",
                      value: "View Results",
                      id: "detailsStep3Submit",
                      onclick: "window.scrollTo(0, 0);"
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.updateQuote(3)
                      }
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "inputPanel__col inputPanel__question",
                  staticStyle: { position: "relative" }
                },
                [
                  _c("input", {
                    staticClass: "form-back-button",
                    staticStyle: {
                      color: "#fff",
                      cursor: "pointer",
                      position: "absolute",
                      left: "0",
                      bottom: "0",
                      "text-align": "left"
                    },
                    attrs: {
                      id: "inputPanelQuestionStep3",
                      type: "submit",
                      value: "< Back"
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.stepBack()
                      }
                    }
                  })
                ]
              )
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "inputPanel__col inputPanel__question" }, [
      _c("label", [
        _vm._v(
          "What do you currently pay for annual maintenance package and royal mail rate updates?"
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "inputPanel__col inputPanel__info" }, [
        _c(
          "div",
          { staticClass: "infoIcon", attrs: { "data-tip": "Info here" } },
          [_vm._v("\n              i\n            ")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "agreement" }, [
      _c(
        "h4",
        {
          staticStyle: {
            "font-size": "1.8rem",
            "margin-bottom": "10px",
            "line-height": "1.2em",
            color: "#0a70e3"
          }
        },
        [_vm._v("Your agreement start and end dates")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "inputPanel__col inputPanel__info" }, [
      _c(
        "div",
        { staticClass: "infoIcon", attrs: { "data-tip": "Info here" } },
        [_vm._v("\n                  i\n                ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "inputPanel__col inputPanel__info" }, [
      _c(
        "div",
        { staticClass: "infoIcon", attrs: { "data-tip": "Info here" } },
        [_vm._v("\n                  i\n                ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "inputPanel" }, [
      _c("div", { staticClass: "inputPanel__col inputPanel__question" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "inputPanel__col inputPanel__question inputPanel__question--right"
      },
      [
        _c("label", [
          _vm._v(
            "What is your current agreement term (Months, Quarters or Years)?"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "inputPanel__col inputPanel__info" }, [
          _c(
            "div",
            { staticClass: "infoIcon", attrs: { "data-tip": "Info here" } },
            [_vm._v("\n                  i\n                ")]
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "inputPanel__col inputPanel__info" }, [
      _c(
        "div",
        { staticClass: "infoIcon", attrs: { "data-tip": "Info here" } },
        [_vm._v("\n                  i\n                ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "inputPanel__col inputPanel__info" }, [
      _c(
        "div",
        { staticClass: "infoIcon", attrs: { "data-tip": "Info here" } },
        [_vm._v("\n                  i\n                ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "inputPanel__col inputPanel__info" }, [
      _c(
        "div",
        { staticClass: "infoIcon", attrs: { "data-tip": "Info here" } },
        [_vm._v("\n                  i\n                ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "inputPanel__col inputPanel__info" }, [
      _c(
        "div",
        { staticClass: "infoIcon", attrs: { "data-tip": "Info here" } },
        [_vm._v("\n                  i\n                ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "saveProgress__content" }, [
      _c("p", [_vm._v("Great! You have completed all that’s required")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e55afe4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e55afe4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Quotes/Form/Step-3/Form.vue
// module id = null
// module chunks = 